import BrandComponents from "../../Masters/Brand/BrandComponents";

function BomTable() {
  let header = [
    { label: "Id", field: "id" },
    { label: "BOM Name", field: "bomname" },
    { label: "part no.", field: "partno" },
    { label: "job no.", field: "jobnumber" },
    { label: "Created Date", field: "createddate" },
    { label: "Created by", field: "createbyname" },
    { label: "Action", field: "action" },
  ];

  return (
    <div>
      <BrandComponents
        header={header}
        tableTitle={"BILL OF MATERIAL (BOM) LIST"}
        apiField={"bom"}
        addButton={"+ ADD"}
        createRoute={"/BOMCreate"}
        updateRoute={"/BOMView"}
        viewRoute={"/BOMView"}
      />
    </div>
  );
}

export default BomTable;